// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4a4d2632","239":"ebfefd68","453":"676ea4a0","455":"ccd43f51"}[chunkId] + ".chunk.js";
};